import type { SignalConfidence } from "@/data/mockBrandSignalsData";

const CONFIDENCE_STRENGTH: Record<SignalConfidence, number> = {
  low: 1,
  medium: 2,
  high: 3,
};

const CONFIDENCE_FILL_COLOR: Record<SignalConfidence, string> = {
  low: "bg-muted-foreground/40",
  medium: "bg-[hsl(234_99%_60%)]",
  high: "bg-[hsl(142_55%_42%)]",
};

export const CONFIDENCE_ORDER: SignalConfidence[] = ["low", "medium", "high"];

export const CONFIDENCE_LABELS: Record<SignalConfidence, string> = {
  low: "Low",
  medium: "Medium",
  high: "High",
};

const BAR_HEIGHTS = ["h-1", "h-1.5", "h-2"];

interface ConfidenceBarsProps {
  confidence: SignalConfidence;
}

export function ConfidenceBars({ confidence }: ConfidenceBarsProps) {
  const strength = CONFIDENCE_STRENGTH[confidence];
  return (
    <div
      className="flex items-end gap-px shrink-0"
      aria-label={`Confidence: ${CONFIDENCE_LABELS[confidence]}`}
    >
      {[1, 2, 3].map((seg) => {
        const filled = seg <= strength;
        return (
          <span
            key={seg}
            className={`w-[3px] rounded-[1px] ${BAR_HEIGHTS[seg - 1]} ${filled ? CONFIDENCE_FILL_COLOR[confidence] : "bg-muted"}`}
          />
        );
      })}
    </div>
  );
}
